import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';


export abstract class RcFormControlAbstract implements OnInit{
    /**
     * Form control - optional
     */
    @Input() control: FormControl;

    /**
     * Will be insert into the DOM element as id
     */
    @Input() elementId: string;

    /**
     * If not empty - will be displayed under the checkbox with role alert and 'invalid-feedback-message' class
     */
    @Input() errorMsg: string;

    /**
     * Component wrapper class name
     */
    @Input() className: string;

    /**
     * accessibility aria-label
     */
    @Input() ariaLabel: string;

    /**
     * accessibility aria-labeledby
     */
    @Input() ariaLabeledBy: string;

    /**
     * accessibility aria-describedby
     */
    @Input() ariaDescribedBy: string;

    @Input()
    set disabled(value: boolean) {
        this._disabled = value ? value : null;
    }
    public _disabled: boolean = null;

    /**
     * Callback function that will be emitted on change
     */
    @Output() onChangedCallback: EventEmitter<any> = new EventEmitter();
    @Output() focusCallback: EventEmitter<any> = new EventEmitter();
    @Output() blurCallback: EventEmitter<any> = new EventEmitter();

    constructor() {

    }

    protected validateInputs() {
        if (!this.elementId) {
            throw new Error('element id must be provided');
        }
    }

    /**
     * Instantiate a form control instance if not provided
     */
    ngOnInit() {
        if (!this.control) {
            this.control = new FormControl();
        }
        this.validateInputs();
    }

    /**
     * get checkbox describedby attribute
     * @returns string
     */
    getAriaDescribedBy(): string {
        return this.ariaDescribedBy ? this.ariaDescribedBy : this.errorElementId;
    }

    /**
     * get error element id
     * @returns string
     */
    get errorElementId(): string {
        return `${this.elementId}-error-label`;
    }

    /**
     * emit an Output function on change
     */
    public onChange($event = null): void {
        if (this.onChangedCallback.observers.length) {
            this.onChangedCallback.emit(this.control.value);
        }
    }

    /**
     * emit an Output function on change
     */
    public onFocus($event = null): void {
        if (this.focusCallback.observers.length) {
            this.focusCallback.emit(this.control.value);
        }
    }

    /**
     * emit an Output function on change
     */
    public onBlur($event = null): void {
        if (this.blurCallback.observers.length) {
            this.blurCallback.emit($event);
        }
    }
}
